export const TRIAL_LENGTH_BY_ROLE = {
  patient: 3,
  p2: 3,
  p4: 3,
  professional: 3,
  facility: 21,
  advertiser: 14,
};

export const getTrialLengthForRole = (role) => {
  if (!role) return TRIAL_LENGTH_BY_ROLE.patient;
  return TRIAL_LENGTH_BY_ROLE[role] || TRIAL_LENGTH_BY_ROLE.patient;
};

export const getTrialLabelForRole = (role) => {
  const length = getTrialLengthForRole(role);
  return `${length}-Day Free Trial`;
};
